import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useStepsContext } from '../../context/StepsContext'
import useRequests from '../../hooks/useRequests'
import { simDataStore } from '../../redux/actions'
import Button from '../Button'

interface Props {
  storeForm: string
  error?: boolean
  label: string
}

const ChipButton = ({ storeForm, error, label }: Props) => {
  const formData = useSelector((state: any) => state[storeForm])
  const [attempts, setAttempts] = useState(1)
  const { newProcedureStep, setNewProcedureStep, chipValidationError, setChipValidationError }: any = useStepsContext()
  const { simValidation } = useRequests(storeForm)
  const { emailOptional, ...chipForm } = formData
  const validity = Object.values({ ...chipForm }).some((value) => !value)
  const dispatch = useDispatch()

  const nextStep = async () => {
    if (chipValidationError) return setChipValidationError(false)
    const data = await simValidation()
    if (!data.success) setAttempts((state: number) => state + 1)
    if (!data.success && attempts === 3) return setChipValidationError(true)
    if (data.success) {
      dispatch(simDataStore({ simNumber: data.simNumber, cellularNumber: data.cellularNumber }))
      setNewProcedureStep(newProcedureStep + 1)
    }
  }
  return (
    <Button
      id="chip-form-continue"
      className="submit-button btn-margin-down btn-margin-top"
      label={label}
      landing={error}
      validity={validity}
      handleSubmit={nextStep}
    />
  )
}

export default ChipButton
